import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { environment } from '../environments/environment';
import { CookieService } from './services/cookie.service';
import { SharedService } from './services/shared.service';
import { ThemeService } from './services/theme.service';
import { ReferenceDataActions } from './store/reference-data/reference-data.actions';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'in-co-sandbox-accounts';
  constructor(private cookieService: CookieService, private themeService: ThemeService, private sharedService: SharedService, private activatedRoute: ActivatedRoute, private store: Store, private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {

    this.registerIcons();

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['redirect']) {
        this.sharedService.setRedirectUrl(params['redirect']);
      }
    });
  }


  ngOnInit() {
    this.store.dispatch(ReferenceDataActions.GET_COUNTRIES());

    this.setTrackingCookies();
    this.themeService.initializeTheme();

  }

  registerIcons() {
    this.iconRegistry.addSvgIcon('login_background', this.sanitizer.bypassSecurityTrustResourceUrl(environment.login_background))
    this.iconRegistry.addSvgIcon('sandbox_logo_white', this.sanitizer.bypassSecurityTrustResourceUrl(environment.sandbox_logo_white))
    this.iconRegistry.addSvgIcon('ic_sbox_brackets', this.sanitizer.bypassSecurityTrustResourceUrl(environment.ic_sbox_brackets));
  }

  private setTrackingCookies() {
    const queryParams = new URL(window.location.href).search;
    const params = new URLSearchParams(queryParams);

    const trackingKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_id', 'utm_term'];

    const hasNewTrackingParam = trackingKeys.some(key => params.has(key));

    if (hasNewTrackingParam) {
      // Delete all existing tracking cookies
      trackingKeys.forEach(key => {
        this.cookieService.deleteCookie(key);
      });

      // Set new tracking cookies from URL parameters
      trackingKeys.forEach(key => {
        const value = params.get(key);
        if (value) {
          this.cookieService.setCookie(key, value, 30);
        }
      });
    }
    if (params.has('ref')) {
      const ref = params.get('ref')!;
      this.cookieService.setCookie('ref', ref, 30);
    }
  }
}
